// Shared contact-email rendering, hardened against Cloudflare's
// "Email Address Obfuscation" feature.
//
// Cloudflare automatically rewrites any raw email address (and any
// `mailto:` href) in the served HTML into a /cdn-cgi/l/email-protection
// link backed by a JS decoder. That endpoint returns 404 to crawlers,
// which Semrush/Google see as a broken internal link — it was producing
// 25 broken links across the site (the footer email on every page, plus
// the terms/privacy/faq pages).
//
// Wrapping the address in Cloudflare's documented `<!--email_off-->` /
// `<!--/email_off-->` directive tells Cloudflare to leave it alone, so it
// renders as a normal, clickable mailto link with no broken /cdn-cgi URL.
// Because JSX can't emit raw HTML comments, we render via
// dangerouslySetInnerHTML.

export const CONTACT_EMAIL = "info@prizo.io";

const emailOffHtml = (inner: string) => `<!--email_off-->${inner}<!--/email_off-->`;

/** Inline, clickable contact email exempt from Cloudflare obfuscation. */
export function ContactEmail({ className }: { className?: string }) {
  return (
    <span
      className={className}
      dangerouslySetInnerHTML={{
        __html: emailOffHtml(
          `<a href="mailto:${CONTACT_EMAIL}" style="color:inherit;text-decoration:none">${CONTACT_EMAIL}</a>`,
        ),
      }}
    />
  );
}

/** Styled mailto button (e.g. "Contact Support") exempt from obfuscation. */
export function ContactEmailButton({
  className,
  children,
}: {
  className?: string;
  children: string;
}) {
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: emailOffHtml(
          `<a href="mailto:${CONTACT_EMAIL}" class="${className ?? ""}">${children}</a>`,
        ),
      }}
    />
  );
}
